
<div class="container-fluid" style="margin-top:100px">
    <div class="row">
        <div class="col-sm-3">
        </div>
        <div class="col-sm-6">
            <p>
                <h2>Enjoy our free delivery service!</h2>
            <p>
                <p>
                    We provide free delivery service to make sure you will receive the products 
                    in good condition, just by fulfilling our minimum purchase as follows. 
                </p>
                <div class="table-responsive">
                    <table class="table">
                        <thead class="bgx">
                            <tr>
                                <th>Catalog</th>
                                <th>Storage Type</th>
                                <th>Min. Purchase</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td rowspan="3" class="align-middle">
                                    <h4>Diamond Products</h4>
                                </td>
                                <td>Dry & Dry AC</td>
                                <td>Rp. 250.000</td>
                            </tr>
                            <tr>
                                <td>Chilled</td>
                                <td>Rp. 250.000</td>
                            </tr>
                            <tr>
                                <td>Frozen</td>
                                <td>Rp. 250.000</td>                                
                            </tr>

                            <tr>
                                <td rowspan="2" class="align-middle">
                                    <h4>Trading Products</h4>
                                </td>
                                <td>Dry & Dry AC</td>
                                <td>Rp. 500.000</td>
                            </tr>
                            <tr>
                                <td>Chilled & Frozen</td>
                                <td>Rp. 500.000</td>
                            </tr>
                            
                            <tr>
                                <td rowspan="2" class="align-middle">
                                    <h4>Fine Food Products</h4>
                                </td>
                                <td>Dry & Dry AC</td>
                                <td>Rp. 500.000</td>
                            </tr>
                            <tr>
                                <td>Chilled & Frozen</td>
                                <td>Rp. 500.000</td>
                            </tr>

                            <tr>
                                <td><h4>F&B Equipment</h4></td>
                                <td>-</td>
                                <td>-</td>
                                
                            </tr>
                        </tbody>
                    </table>
                </div>
        </div>
        <div class="col-sm-3">
        </div>
    </div>
</div>